import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const rtlLanguages = ['ps', 'da'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

const detectedLang = i18n.language || 'en';
document.documentElement.dir = rtlLanguages.includes(detectedLang) ? 'rtl' : 'ltr';
document.documentElement.lang = detectedLang === 'da' ? 'prs' : detectedLang;

export default i18n;